<template>
	<div class="component--process-map" :data-component-id="templateData.post.id">
		<div 
            class="lanes" 
            id="lanes">
			<div class="lanes--inner" id="lanes--inner">
				<template
					v-for="lane in lanes"
					:key="lane.index"
					>
					<ProcessMapLane 
						:lane="lane"
                        :style="lane.laneStyle"
						/>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import LeaderLine from 'leader-line-new'
import AnimEvent from 'anim-event'

import ProcessMapLane from '@vueapp/components/process-maps/ProcessMapLane.vue'

export default {
	name: 'ProcessMapComponent',
	data() {
		return {
            lanesShadowStyle: null,
		}
	},
	components: {
		ProcessMapLane
	},
	props: {
		templateData: {
			type: Object,
			default: {}
		}
	},

	methods: {
		getRedirectNode( action_btn ) {
            if ( ! action_btn.result_event ) return null
            if ( 'close-module' == action_btn.result_event ) {
                return 'close-module'
            }
            return decodeURI(action_btn.result_event)
        },

        onWindowResize() {
            const w = window.innerWidth,
                h = window.innerHeight

            // console.log('onWindowResize', w, h)
            // if ( $('#lanes').length ) {
            const l = document.getElementById('lanes'),
                li = document.getElementById('lanes') ? document.getElementById('lanes').getElementsByClassName('lanes--inner')[0] : null,
                ls = document.getElementById('lanes-shadow')
            // console.log(li)
            if ( l ) {
                const obj1 = { 'width': li.offsetWidth + 'px', 'height': ( l.offsetHeight < li.offsetHeight ? l.offsetHeight : li.offsetHeight ) + 'px' },
                    // obj2 = l.offset()
                    rect = l.getBoundingClientRect(),
                    obj2 = { 
                        top: ( rect.top + window.scrollY ) + 'px', 
                        left: ( rect.left + window.scrollX ) + 'px'
                    }
                // console.log(obj1, obj2)
                // ls.css( { ...obj1, ...obj2 })
                this.lanesShadowStyle = { ...obj1, ...obj2 }
                console.log( ls, ls.style, { ...this.lanesShadowStyle })
                Object.assign( ls.style, { ...this.lanesShadowStyle })
                // this.emitter.emit('lansesShadowStyle', this.lanesShadowStyle)
                // }
                // console.log($('#lanes--inner').offset())
            }
        },
        onWindowScroll() {
            // const st = window.scrollTop
            // console.log('scrolling')
        }
	},
	computed: {
        lanes() {
            return this.templateData.lanes.map( (item, i) => {
                // console.log(item.steps.length)
                let minHeight = item.steps.length ? 220 : 80,
                    labelsMinHeight = ( item.label.length * 8 ) + 40 

                console.log('labelsMinHeight::', labelsMinHeight)

                if ( labelsMinHeight > minHeight ) {
                    minHeight = labelsMinHeight
                }

                item.laneStyle = {
                    minHeight: minHeight + 'px'
                }
                return item
            })
        }
	},


    beforeCreate() {
        // console.log('process map before create')
        $('body').append('<div class="lanes-shadow-wrap"><div id="lanes-shadow"></div></div>')
    },

    created() {

        // console.log('process map created')

        // if ( $('#lanes--inner').length ) {
        
        // } else {
            // $('.lanes-shadow-wrap').remove()
        // }

        window.addEventListener("resize", this.onWindowResize);
        
        window.addEventListener( 'scroll', this.onWindowResize);
    },

    unmounted() {
        // console.log('process map unmounted')

        window.removeEventListener('resize', this.onWindowResize);
        window.removeEventListener('scroll', this.onWindowResize)

        $('.lanes-shadow-wrap').remove()
    },

	mounted() {
        // console.log('process map mounted')


        const lines = [];
        const scrollableBox = document.getElementById('lanes'),
        	steps = Array.from( document.getElementsByClassName('step') )
        	// console.log('steps::', steps)
        for ( let i = 0; i < steps.length - 1; i++ ) {
            // console.log(i)
            // if ( $(`.step-card[data-pos=${i}]`).length && $(`.step-card[data-pos=${i+1}]`).length ) {
                // console.log(
                //     $(`.step-card[data-pos=${i}]`).length,
                //     $(`.step-card[data-pos=${i+1}]`).length
                //     )

        		let first = document.querySelector(`.step-card[data-pos="${i}"] .Card`),
        			second = document.querySelector(`.step-card[data-pos="${i+1}"] .Card`)

    			// console.log('first::', `.step-card[data-pos="${i}"] .Card`, first)
                const line = new LeaderLine(
                  first,
                  second,
                  {
                    color: this.templateData.options.arrows_color,
                    hide: true,
                    path: 'grid'
                  }
                )
                setTimeout(function(){
                    line.show([
                        'draw'
                    ])    
                }, 200) 

                lines.push( line )
            // }
        }

        
        // console.log('scrollableBox::', scrollableBox)
        scrollableBox.addEventListener('scroll', AnimEvent.add(function() {
            lines.forEach( line => {
                line.position();    
                // console.log(line)
            })
        }), false);

        
        const lanes = document.getElementsByClassName('lanes--inner')
        // const lanes = document.getElementById('lanes--inner')
        // const rect = lanes.getBoundingClientRect()

        // function getOffset( el ) {
        //     var _x = 0;
        //     var _y = 0;
        //     while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
        //         _x += el.offsetLeft - el.scrollLeft;
        //         _y += el.offsetTop - el.scrollTop;
        //         el = el.offsetParent;
        //     }
        //     return { top: _y, left: _x };
        // }

        

        
        // console.log(getOffset2(lanes), rect.top, rect.right, rect.bottom, rect.left);
    


        // $('.step-card').each(function(){
        //     let $el = $(this)
        //     console.log(
        //             $el,
        //             document.getElementById(oldId),
        //             document.getElementById('next-' + ( $el.data('pos') + 1 ) ),
        //             $el.attr('data-pos')
        //             )
            
        //     // if ( $(el).attr('id') != 'end' ) {
        //         new LeaderLine(
        //           document.getElementById(oldId),
        //           document.getElementById('next-' + ( $el.data('pos') + 1 ) )
        //         );        
        //         oldId = 'next-' + $el.data('pos') + 1
        //     // }
        // })
        if ( $('#next-1').length ) {
            
        }

        window.dispatchEvent(new Event('resize'));
    }
    
}
</script>